import date_utils from './date_utils';
import {
    $,
    createSVG
} from './svg_utils';
import Bar from './bar';
import Arrow from './arrow';
import Popup from './popup';
import Dimension from './dimension';
import Xscroll from './scroll';
import Xrender from './render';

import './gantt.scss';

const VIEW_MODE = {
    HOUR: 'Hour',
    QUARTER_DAY: 'Quarter Day',
    HALF_DAY: 'Half Day',
    DAY: 'Day',
    WEEK: 'Week',
    MONTH: 'Month',
    Quarterly_Month: 'Quarterly Month',
    QUARTERLY: 'Quarterly',
    YEAR: 'Year'
};

export default class Gantt {
    constructor(wrapper, tasks, options) {
        let that = this;
        this.gantt_id = generate_id({
            name: 'k-gantt-'
        });
        this.touch =
            'ontouchstart' in window ||
            (window.DocumentTouch && document instanceof window.DocumentTouch);
        this.setup_wrapper(wrapper);
        this.setup_options(options);
        this.setup_tasks(tasks);
        this.setup_dimension(this.tasks);
        // initialize with default view mode
        this.change_view_mode();
        this.bind_events();

        this.bind_container_events();
        this.bind_taskinfo_events();

        that.elX = 0;
        that.elY = 0;
        let box = that.$taskinfo_content.getBoundingClientRect();
        this.contentTop = box.top;
        this.contentLeft = box.left;
        document.addEventListener(
            'mousemove',
            function (event) {
                let touch = event || window.event;
                that.elX = touch.clientX || touch.pageX;
                that.elY = touch.clientY || touch.pageY;
                // //console.logmousemove',that.elX, that.elY);
            },
            false
        );
        document.addEventListener(
            'touchmove',
            function (event) {
                // let event = event || window.event;
                let touch = event.changedTouches[0];
                that.elX = touch.clientX || touch.pageX;
                that.elY = touch.clientY || touch.pageY;
            },
            false
        );
    }

    setup_wrapper(element) {
        let svg_element, wrapper_element;

        // CSS Selector is passed
        if (typeof element === 'string') {
            element = document.querySelector(element);
        }

        // get the SVGElement
        if (element instanceof HTMLElement) {
            wrapper_element = element;
            svg_element = element.querySelector('svg');
        } else if (element instanceof SVGElement) {
            svg_element = element;
        } else {
            throw new TypeError(
                'Frappé Gantt only supports usage of a string CSS selector,' +
                " HTML DOM element or SVG DOM element for the 'element' parameter"
            );
        }

        // svg element
        if (!svg_element) {
            // create it
            this.$svg = createSVG('svg', {
                append_to: wrapper_element,
                class: 'gantt'
            });
        } else {
            this.$svg = svg_element;
            this.$svg.classList.add('gantt');
        }

        // wrapper element
        this.$container = document.createElement('div');
        this.$container.classList.add('gantt-container');

        //左侧字段显示部分
        this.$taskinfo = document.createElement('div');
        this.$taskinfo.classList.add('task-info-wrapper');
        this.$container.appendChild(this.$taskinfo);

        this.$taskresize = document.createElement('div');
        this.$taskresize.classList.add('task-resize-wrapper');
        this.$container.appendChild(this.$taskresize);

        this.$taskinfo_header = document.createElement('div');
        this.$taskinfo_header.classList.add('task-info-header-wrapper');
        this.$taskinfo.appendChild(this.$taskinfo_header);

        this.$svg_data_header_shell = document.createElement('div');
        this.$svg_data_header_shell.classList.add(
            'task-info-content-wrapper-gantt-shell'
        );
        this.$taskinfo_header.appendChild(this.$svg_data_header_shell);

        this.$svg_data_header = createSVG('svg', {
            append_to: this.$svg_data_header_shell,
            class: 'gantt'
        });

        this.$taskinfo_content = document.createElement('div');
        this.$taskinfo_content.classList.add('task-info-content-wrapper');
        this.$taskinfo.appendChild(this.$taskinfo_content);

        this.$taskinfo_content_svgshell = document.createElement('div');
        this.$taskinfo_content_svgshell.classList.add(
            'task-info-content-wrapper-gantt-shell'
        );
        this.$taskinfo_content.appendChild(this.$taskinfo_content_svgshell);
        this.$svg_data_content = createSVG('svg', {
            append_to: this.$taskinfo_content_svgshell,
            class: 'gantt'
        });

        //右侧task部分
        this.$task = document.createElement('div');
        this.$task.classList.add('task-wrapper');
        this.$container.appendChild(this.$task);

        this.$task_header = document.createElement('div');
        this.$task_header.classList.add('task-header-wrapper');

        this.$svg_header_shell = document.createElement('div');
        this.$svg_header_shell.classList.add('task-header-wrapper');
        this.$task_header.appendChild(this.$svg_header_shell);

        this.$svg_header = createSVG('svg', {
            append_to: this.$svg_header_shell,
            class: 'gantt'
        });

        this.$task.appendChild(this.$task_header);

        this.$task_content = document.createElement('div');
        this.$task_content.classList.add('task-content-wrapper');
        this.$task.appendChild(this.$task_content);

        this.$task_content_shell = document.createElement('div');
        this.$task_content_shell.classList.add('task-content-wrapper-shell');
        this.$task_content.appendChild(this.$task_content_shell);

        const parent_element = this.$svg.parentElement || this.$svg.parentNode;
        parent_element.appendChild(this.$container);
        this.$task_content_shell.appendChild(this.$svg);

        // popup wrapper
        this.popup_wrapper = document.createElement('div');
        this.popup_wrapper.classList.add('popup-wrapper');
        this.$task_content.appendChild(this.popup_wrapper);
    }

    setup_options(options) {
        const default_options = {
            // column_width: 30,
            columns: null,
            step: 24,
            view_modes: [...Object.values(VIEW_MODE)],
            bar_height: 20,
            bar_corner_radius: 3,
            arrow_curve: 5,
            padding: 18,
            view_mode: 'Day',
            date_format: 'YYYY-MM-DD',
            popup_trigger: this.touch ?
                ' click touchstart mousedown mousemove' : 'mousemove',
            custom_popup_html: null,
            DummyData: 'auto', //5条虚拟数据占位，否则空了
            language: 'en',
            bar_drag: false //任务列表的拖动功能
        };
        this.options = Object.assign({}, default_options, options);
    }

    make_task(task, i) {
        task._start = date_utils.parse(task.start);
        task._end = date_utils.parse(task.end);

        // make task invalid if duration too large
        // if (date_utils.diff(task._end, task._start, 'year') > 10) {
        //     task.end = null;
        // }

        // cache index
        task._index = i;

        // invalid dates
        if (!task.start && !task.end) {
            const today = date_utils.today();
            task._start = today;
            task._end = date_utils.add(today, 2, 'day');
        }

        if (!task.start && task.end) {
            task._start = date_utils.add(task._end, -2, 'day');
        }

        if (task.start && !task.end) {
            task._end = date_utils.add(task._start, 2, 'day');
        }

        // if hours is not set, assume the last day is full day
        // e.g: 2018-09-09 becomes 2018-09-09 23:59:59
        const task_end_values = date_utils.get_date_values(task._end);
        if (task_end_values.slice(3).every(d => d === 0)) {
            task._end = date_utils.add(task._end, 24, 'hour');
        }

        // invalid flag
        if (!task.start || !task.end) {
            task.invalid = true;
        }
        if (task._end == 'Invalid Date' || !task._start == 'Invalid Date') {
            task.invalid = true;
        }
        if (!task.invalid && task._start.getTime() >= task._end.getTime())
            task.invalid = true;

        //出现了多个时间段
        if (task.hasOwnProperty('datas')) {
            let len = task.datas.length;
            for (let index = 0; index < len; index++) {
                task.datas[index] = this.make_task(task.datas[index], i);
                if (task.invalid && !task.datas[index].invalid) {
                    // 覆盖主数据内容
                    task.datas[index].invalid = false;
                    task.datas[index]._index = i;
                    task = Object.assign({}, task, task.datas[index]);
                    task.datas[index].invalid = true;
                }
            }
        }
        // dependencies
        if (typeof task.dependencies === 'string' || !task.dependencies) {
            let deps = [];
            if (task.dependencies) {
                deps = task.dependencies
                    .split(',')
                    .map(d => d.trim())
                    .filter(d => d);
            }
            task.dependencies = deps;
        }

        // uids
        if (!task.id) {
            task.id = generate_id(task);
        }
        if (!task.dependencieId) {
            //用于专门处理依赖id任务之间的id关系 ，如果不存在默认用任务的id处理
            task.dependencieId = task.id;
        }
        if (task.legend) {
            task.legend = task.legend;
        }
        return task;
    }

    setup_tasks(tasks) {
        // prepare tasks
        if(tasks){ //空数据报错
            this.tasks = tasks.map((task, i) => {
                // convert to Date objects
                task = this.make_task(task, i);
                return task;
            }) ;
        }else{
            this.tasks = []
        }
        
        // if (this.tasks.length == 0) {

        let DummyData = this.options.DummyData;
        if (DummyData == 'auto') {
            DummyData = Math.floor(
                (this.$task_content.clientHeight || 100) /
                (this.options.bar_height + this.options.padding)
            );
            if (this.tasks.length > 0) {
                if (this.tasks.length < DummyData) {
                    DummyData = DummyData - this.tasks.length - 1;
                } else {
                    DummyData = 0;
                }
            }
        }

        for (let i = 0; i < DummyData; i++) {
            this.tasks.push({
                invalid: true,
                dependencies: []
            });
        }
        // }
        this.setup_dependencies();
    }

    setup_dimension(tasks) {
        if (!this.options.columns || this.options.columns.length == 0) return;

        let t1 = new Date().getTime();
        this.dimension = new Dimension(
            this,
            tasks,
            this.options.columns,
            this.$svg_data_header,
            this.$svg_data_content
        );

        let content_width = this.dimension.content_width;
        if (
            this.$container.clientWidth > 0 &&
            this.$container.clientWidth - 20 < this.dimension.content_width
        ) {
            content_width = this.$container.clientWidth - 20;
        }

        let t2 = new Date().getTime();
        //console.logsetup_dimension 消耗：' + (t2 - t1));
        this.$taskinfo.style.width = content_width + 1 + 'px';
        this.$taskinfoWidth = content_width;

        this.$svg_data_header.setAttribute(
            'width',
            this.dimension.content_width + 1
        );
        this.$svg_data_header_shell.style.width =
            this.dimension.content_width + 1 + 'px';

        this.$svg_data_content.setAttribute(
            'width',
            this.dimension.content_width + 1
        );
        this.$taskinfo_content_svgshell.style.width =
            this.dimension.content_width + 1 + 'px';

        this.$task.style.left = content_width + 'px';
        this.$task.style.width = 'calc( 100% - ' + content_width + 'px )';
        this.$taskresize.style.left = content_width - 20 + 'px';

        if (this.options.onGetResize) {
            let cache_content_width = this.options.onGetResize();
            if (cache_content_width < 40) return;
            this.$taskresize.style.left = cache_content_width - 20 + 'px';
            //左侧任务列表的信息
            this.$taskinfo.style.width = cache_content_width + 'px';
            //右侧任务列表的信息
            this.$task.style.left = cache_content_width + 'px';
            this.$task.style.width =
                'calc( 100% - ' + cache_content_width + 'px )';
            let offsetwidth = cache_content_width - this.$taskinfoWidth;
            if (offsetwidth > 1) {
                this.$svg_data_header.setAttribute(
                    'width',
                    cache_content_width
                );
                this.$svg_data_content.setAttribute(
                    'width',
                    cache_content_width
                );
                this.dimension.render(offsetwidth);
            } else {
                this.dimension.render(0);
            }
        }

    }

    setup_dependencies() {
        this.dependency_map = {};
        for (let t of this.tasks) {
            for (let d of t.dependencies) {
                this.dependency_map[d] = this.dependency_map[d] || [];
                this.dependency_map[d].push(t.id);
            }
        }
    }

    refresh(tasks) {
        this.setup_tasks(tasks);
        this.change_view_mode();
    }

    change_view_mode(mode) {
        if (mode == this.options.view_mode) return;
        mode = mode || this.options.view_mode;
        this.update_view_scale(mode);

        let t1 = new Date().getTime();
        this.setup_dates();
        let t2 = new Date().getTime();
        //console.logsetup_dates 消耗：' + (t2 - t1));
        t1 = new Date().getTime();
        this.render();
        t2 = new Date().getTime();
        //console.logrender 消耗：' + (t2 - t1));
        // fire viewmode_change event
        this.trigger_event('view_change', [mode]);
    }

    update_view_scale(view_mode) {
        this.options.view_mode = view_mode;
        if (view_mode === VIEW_MODE.HOUR) {
            this.options.step = 24 / 24;
            this.options.column_width = 38;
        } else if (view_mode === VIEW_MODE.DAY) {
            this.options.step = 24;
            this.options.column_width = 38;
        } else if (view_mode === VIEW_MODE.HALF_DAY) {
            this.options.step = 24 / 2;
            this.options.column_width = 38;
        } else if (view_mode === VIEW_MODE.QUARTER_DAY) {
            this.options.step = 24 / 4;
            this.options.column_width = 38;
        } else if (view_mode === VIEW_MODE.WEEK) {
            this.options.step = 24;
            this.options.column_width = 24;
        } else if (view_mode === VIEW_MODE.MONTH) {
            this.options.step = 24 * 30;
            this.options.column_width = 120;
            this.options.column_size = 120 / 30 / 24;
        } else if (view_mode === VIEW_MODE.Quarterly_Month) {
            this.options.step = 24 * 30;
            this.options.column_width = 120;
            this.options.column_size = 120 / 30 / 24;
        } else if (view_mode === VIEW_MODE.YEAR) {
            this.options.step = 24 * 365 / 2;
            this.options.column_width = 120;
            this.options.column_size = 120 / 365 / 24;
        } else if (view_mode === VIEW_MODE.QUARTERLY) {
            this.options.step = 24 * 90;
            this.options.column_width = 120;
            this.options.column_size = 120 / 90 / 24;
        }
    }

    setup_dates() {
        this.setup_gantt_dates();
        this.setup_date_values();
    }

    setup_gantt_dates() {
        this.gantt_start = this.gantt_end = null;

        for (let task of this.tasks) {
            // set global start and end date
            if (!this.gantt_start || task._start < this.gantt_start) {
                this.gantt_start = task._start;
            }
            if (!this.gantt_end || task._end > this.gantt_end) {
                this.gantt_end = task._end;
            }
            if (task.hasOwnProperty('datas')) {
                let len = task.datas.length;
                for (let index = 0; index < len; index++) {
                    if (
                        !this.gantt_start ||
                        task.datas[index]._start < this.gantt_start
                    ) {
                        this.gantt_start = task.datas[index]._start;
                    }
                    if (
                        !this.gantt_end ||
                        task.datas[index]._end > this.gantt_end
                    ) {
                        this.gantt_end = task.datas[index]._end;
                    }

                    // task.datas[index] = this.make_task(task.datas[i]);
                }
            }
        }

        if (!this.gantt_start) {
            this.gantt_start = new Date();
        }

        if (!this.gantt_end) {
            this.gantt_end = new Date();
        }

        this.gantt_start = date_utils.start_of(this.gantt_start, 'day');
        this.gantt_end = date_utils.start_of(this.gantt_end, 'day');

        let taskWidth = this.$container.offsetWidth;
        // add date padding on both sides
        if (this.view_is([VIEW_MODE.HOUR, VIEW_MODE.QUARTER_DAY])) {
            this.gantt_start = date_utils.add(this.gantt_start, -1, 'day');
            let taskday = date_utils.diff(
                this.gantt_end,
                this.gantt_start,
                'hour'
            );
            let widthDay = taskWidth / this.options.column_width;
            if (taskday > widthDay) {
                // 任务比面板要宽
                this.gantt_end = date_utils.add(this.gantt_end, 1, 'day');
            } else {
                let offsetday = widthDay - taskday;
                if (offsetday > 0) {
                    this.gantt_end = date_utils.add(
                        this.gantt_end,
                        Math.ceil(offsetday / 24),
                        'day'
                    );
                }
            }
        } else if (this.view_is(VIEW_MODE.HALF_DAY)) {
            let taskday = date_utils.diff(
                this.gantt_end,
                this.gantt_start,
                'day'
            );
            this.gantt_start.setHours(0);
            this.gantt_start.setMinutes(0);
            this.gantt_start.setSeconds(0);
            this.gantt_start.setMilliseconds(0);
            let widthDay = taskWidth / (this.options.column_width * 2);
            this.gantt_start = date_utils.add(this.gantt_start, -1, 'day');
            if (taskday > widthDay) {
                // 任务比面板要宽
                this.gantt_end = date_utils.add(this.gantt_end, 2, 'day');
            } else {
                let offsetday = widthDay - taskday;
                if (offsetday > 0) {
                    this.gantt_end = date_utils.add(
                        this.gantt_end,
                        offsetday,
                        'day'
                    );
                }
            }
        } else if (this.view_is(VIEW_MODE.YEAR)) {
            let taskday =
                date_utils.diff(this.gantt_end, this.gantt_start, 'month') / 6;

            this.gantt_start.setMonth(0);
            this.gantt_start.setDate(1);
            this.gantt_start.setHours(0);
            this.gantt_start.setMinutes(0);
            this.gantt_start.setSeconds(0);
            this.gantt_start.setMilliseconds(0);

            let widthDay = taskWidth / this.options.column_width;
            if (taskday > widthDay) {
                this.gantt_end = date_utils.add(this.gantt_end, 2, 'year');
            } else {
                let offsetday = widthDay - taskday - 1;
                if (offsetday > 0) {
                    this.gantt_end = date_utils.add(
                        this.gantt_end,
                        offsetday * 6,
                        'month'
                    );
                }
            }
            this.gantt_end.setMonth(6);
            this.gantt_end.setDate(0);
        } else if (this.view_is(VIEW_MODE.MONTH)) {
            let taskday = date_utils.diff(
                this.gantt_end,
                this.gantt_start,
                'month'
            );
            this.gantt_start.setDate(1);
            this.gantt_start.setHours(0);
            this.gantt_start.setMinutes(0);
            this.gantt_start.setSeconds(0);
            this.gantt_start.setMilliseconds(0);
            this.gantt_start = date_utils.add(this.gantt_start, -1, 'month');
            let widthDay = taskWidth / this.options.column_width;
            if (taskday > widthDay) {
                this.gantt_end = date_utils.add(this.gantt_end, 1, 'month');
            } else {
                // -2 至少会默认占2个月
                let offsetday = widthDay - taskday - 1;
                if (offsetday > 0) {
                    this.gantt_end = date_utils.add(
                        this.gantt_end,
                        offsetday,
                        'month'
                    );
                }
            }
        } else if (this.view_is(VIEW_MODE.Quarterly_Month)) {
            let taskday = date_utils.diff(
                this.gantt_end,
                this.gantt_start,
                'month'
            );
            this.gantt_start.setDate(1);
            this.gantt_start.setHours(0);
            this.gantt_start.setMinutes(0);
            this.gantt_start.setSeconds(0);
            this.gantt_start.setMilliseconds(0);
            this.gantt_start = date_utils.add(this.gantt_start, -1, 'month');
            // if (this.gantt_start.getMonth() <= 2) {
            //     //1季度
            //     this.gantt_start = date_utils.start_of(
            //         this.gantt_start,
            //         'year'
            //     );
            // } else if (this.gantt_start.getMonth() <= 5) {
            //     //第二季度
            //     this.gantt_start.setMonth(3);
            //     this.gantt_start.setDate(1);
            // } else if (this.gantt_start.getMonth() <= 8) {
            //     //第三季度
            //     this.gantt_start.setMonth(6);
            //     this.gantt_start.setDate(1);
            // } else if (this.gantt_start.getMonth() <= 11) {
            //     //第四季度
            //     this.gantt_start.setMonth(9);
            //     this.gantt_start.setDate(1);
            // }
            let widthDay = taskWidth / this.options.column_width;
            if (taskday > widthDay) {
                this.gantt_end = date_utils.add(this.gantt_end, 3, 'month');
            } else {
                // -一个季度占的数量
                let offsetday = widthDay - taskday;
                if (offsetday > 0) {
                    this.gantt_end = date_utils.add(
                        this.gantt_end,
                        offsetday,
                        'month'
                    );
                }
            }
        } else if (this.view_is([VIEW_MODE.QUARTERLY])) {
            // this.gantt_start.setMonth(0);
            // this.gantt_start.setDate(1);

            let taskday =
                date_utils.diff(this.gantt_end, this.gantt_start, 'month') / 3;
            this.gantt_start = date_utils.add(this.gantt_start, -3, 'month');
            if (this.gantt_start.getMonth() <= 2) {
                //1季度
                this.gantt_start = date_utils.start_of(
                    this.gantt_start,
                    'year'
                );
            } else if (this.gantt_start.getMonth() <= 5) {
                //第二季度
                this.gantt_start.setMonth(3);
                this.gantt_start.setDate(1);
            } else if (this.gantt_start.getMonth() <= 8) {
                //第三季度
                this.gantt_start.setMonth(6);
                this.gantt_start.setDate(1);
            } else if (this.gantt_start.getMonth() <= 11) {
                //第四季度
                this.gantt_start.setMonth(9);
                this.gantt_start.setDate(1);
            }
            let widthDay = taskWidth / this.options.column_width;

            if (taskday > widthDay) {
                this.gantt_end = date_utils.add(this.gantt_end, 3, 'month');
            } else {
                // -一个季度占的数量
                let offsetday = widthDay - taskday;
                if (offsetday > 0) {
                    this.gantt_end = date_utils.add(
                        this.gantt_end,
                        offsetday * 3,
                        'month'
                    );
                }
            }

            // let lastend = taskWidth / this.options.column_width / 4;
            // if (lastend > 4) {
            //     lastend = lastend - 1;
            // }
            // this.gantt_end = date_utils.add(this.gantt_end, lastend, 'year');
            // this.gantt_end.setMonth(8);
            // this.gantt_end.setDate(31);
        } else if (this.view_is([VIEW_MODE.WEEK])) {
            let taskday = date_utils.diff(
                this.gantt_end,
                this.gantt_start,
                'day'
            );
            this.gantt_start.setHours(0);
            this.gantt_start.setMinutes(0);
            this.gantt_start.setSeconds(0);
            this.gantt_start.setMilliseconds(0);
            let widthDay = taskWidth / this.options.column_width;
            // 从周一 开始
            this.gantt_start = date_utils.add(
                this.gantt_start,
                0 - this.gantt_start.getDay() - 1,
                'day'
            );
            if (taskday > widthDay) {
                // 任务比面板要宽
                this.gantt_end = date_utils.add(this.gantt_end, 1, 'day');
            } else {
                let offsetday = widthDay - taskday;
                if (offsetday > 0) {
                    this.gantt_end = date_utils.add(
                        this.gantt_end,
                        offsetday,
                        'day'
                    );
                }
            }
        } else {
            let taskday = date_utils.diff(
                this.gantt_end,
                this.gantt_start,
                'day'
            );
            this.gantt_start.setHours(0);
            this.gantt_start.setMinutes(0);
            this.gantt_start.setSeconds(0);
            this.gantt_start.setMilliseconds(0);
            let widthDay = taskWidth / this.options.column_width;
            this.gantt_start = date_utils.add(this.gantt_start, -2, 'day');
            if (taskday > widthDay) {
                // 任务比面板要宽
                this.gantt_end = date_utils.add(this.gantt_end, 1, 'day');
            } else {
                let offsetday = widthDay - taskday;
                if (offsetday > 0) {
                    this.gantt_end = date_utils.add(
                        this.gantt_end,
                        offsetday,
                        'day'
                    );
                }
            }
        }
    }

    setup_date_values() {
        this.dates = [];
        let cur_date = null;

        while (cur_date === null || cur_date < this.gantt_end) {
            if (!cur_date) {
                cur_date = date_utils.clone(this.gantt_start);
            } else {
                if (this.view_is(VIEW_MODE.YEAR)) {
                    cur_date = date_utils.add(cur_date, 6, 'month');
                } else if (this.view_is([VIEW_MODE.QUARTERLY])) {
                    cur_date = date_utils.add(cur_date, 3, 'month');
                } else if (
                    this.view_is([VIEW_MODE.MONTH, VIEW_MODE.Quarterly_Month])
                ) {
                    cur_date = date_utils.add(cur_date, 1, 'month');
                } else if (this.view_is([VIEW_MODE.WEEK])) {
                    cur_date = date_utils.add(cur_date, 1, 'day');
                } else {
                    cur_date = date_utils.add(
                        cur_date,
                        this.options.step,
                        'hour'
                    );
                }
            }
            this.dates.push(cur_date);
        }
    }

    debounce(fn, wait, immediate) {
        let timer;
        return function () {
            if (timer) clearTimeout(timer);
            if (immediate) {
                // 如果已经执行过，不再执行
                let callNow = !timer;
                timer = setTimeout(() => {
                    timer = null;
                }, wait);
                if (callNow) {
                    fn.apply(this, arguments)
                }
            } else {
                timer = setTimeout(() => {
                    fn.apply(this, arguments)
                }, wait);
            }
        }
    }
    bind_events() {
        // this.bind_grid_click();
        // this.bind_bar_events();
        let that = this;
        if (this.options.popup_trigger)
            $.on(this.$svg, this.options.popup_trigger, e => {
                if (['gantt'].indexOf(e.target.className.baseVal) > -1) {
                    this.unselect_all();
                    this.hide_popup();
                }
            });
        if (this.options.popup_trigger)
            $.on(this.$svg_header, this.options.popup_trigger, () => {
                this.unselect_all();
                this.hide_popup();
            });
        if (this.options.popup_trigger)
            $.on(this.$svg_data_content, this.options.popup_trigger, () => {
                this.unselect_all();
                this.hide_popup();
            });

        let c = function () {
            // 拖动到左侧，不能小第一个维度的宽度 保存最小宽度40的空间
            if (40 > that.newWidth) {
                return;
            }
            if (that.$container.clientWidth - 20 < that.newWidth) {
                return;
            }

            that.$taskresize.style.left = that.newWidth - 20 + 'px';
            //左侧任务列表的信息
            that.$taskinfo.style.width = that.newWidth + 'px';
            //右侧任务列表的信息
            that.$task.style.left = that.newWidth + 'px';
            that.$svg.setAttribute('width', that.$task_content.offsetWidth);
            that.$svg_header.setAttribute(
                'width',
                that.$task_content.offsetWidth
            );

            that.$task.style.width = 'calc( 100% - ' + that.newWidth + 'px )';
            let offsetwidth = that.newWidth - that.$taskinfoWidth;
            if (offsetwidth > 1) {
                that.$svg_data_header.setAttribute('width', that.newWidth);
                that.$svg_data_content.setAttribute('width', that.newWidth);
                that.dimension.render(offsetwidth);
            } else {
                that.dimension.render(0);
                // that.$svg_data_header.setAttribute(
                //     'width',
                //     that.$taskinfoWidth
                // );
                // that.$svg_data_content.setAttribute(
                //     'width',
                //     that.$taskinfoWidth
                // );
            }

            // that.set_Xscroll();
            that.XscrollTask.calculateScrollBar();
            // this.XscrollTask.reset();
            that.XscrollInfo.calculateScrollBar();
            that.XscrollInfo.reset();
            that.report_task_pos(
                that.$taskinfo_content_svgshell.style.marginLeft ?
                parseFloat(
                    that.$taskinfo_content_svgshell.style.marginLeft
                ) :
                0,
                that.$taskinfo_content_svgshell.style.marginTop ?
                parseFloat(
                    that.$taskinfo_content_svgshell.style.marginTop
                ) :
                0
            )
            that.options.onChangeResize &&
                that.options.onChangeResize(that.newWidth);
            that.upper_date_automove(that.tasksOffset);
        };
        let mousedrag = false;
        let mousedragx = 0;
        let infowidget = 0;
        let mousedown = function (event) {
            let e = event;
            if (event.changedTouches) e = event.changedTouches[0];
            mousedrag = true;
            mousedragx = e.clientX;
            infowidget = that.$taskinfo_content.clientWidth;
            let mouseup = function (e) {
                // console.log("mousemove")
                mousedrag = false;
                mousedragx = 0;
                document.removeEventListener('mouseup', mouseup, false);
                document.removeEventListener('touchend', mouseup, false);
            };
            document.addEventListener('mouseup', mouseup, false);
            document.addEventListener('touchend', mouseup, false);
            event.preventDefault();
            event.stopPropagation();
            return false;
        };
        document.addEventListener(
            'mousemove',
            that.debounce(function (event) {
                let e = event;
                if (event.changedTouches) e = event.changedTouches[0];
                if (mousedrag) {
                    if (e.clientX > 0) {
                        let ss = e.clientX - mousedragx;
                        that.newWidth = infowidget + ss;
                        c();
                    }
                }
                event.preventDefault();
                event.stopPropagation();
                return false;
            }, 5),
            false
        );
        that.$taskresize.addEventListener(
            'touchmove',
            that.debounce(function (event) {
                let e = event;
                if (event.changedTouches) e = event.changedTouches[0];
                if (mousedrag) {
                    if (e.clientX > 0) {
                        // console.log(e.currentTarget);
                        let ss = e.clientX - mousedragx;
                        that.newWidth = infowidget + ss;
                        c();
                    }
                }
                event.preventDefault();
                event.stopPropagation();
                return false;
            }, 5),
            false
        );
        that.$taskresize.addEventListener('mousedown', mousedown, false);
        that.$taskresize.addEventListener('touchstart', mousedown, false);
        if (!this.options.columns || this.options.columns.length == 0) {
            that.$taskresize.style.display = 'none';
        }
    }

    render() {
        this.clear();
        let t1 = new Date().getTime();
        this.setup_layers();
        let t2 = new Date().getTime();
        //console.logsetup_layers 消耗：' + (t2 - t1));
        t1 = new Date().getTime();
        this.make_dates();
        t2 = new Date().getTime();
        //console.logmake_dates 消耗：' + (t2 - t1));
        // t1 = new Date().getTime();
        // this.make_grid();
        // t2 = new Date().getTime();
        // //console.logmake_grid 消耗：' + (t2 - t1));
        t1 = new Date().getTime();
        this.make_bars();
        t2 = new Date().getTime();
        //console.logmake_bars 消耗：' + (t2 - t1));
        t1 = new Date().getTime();
        this.make_arrows();
        t2 = new Date().getTime();
        //console.logmake_arrows 消耗：' + (t2 - t1));
        t1 = new Date().getTime();
        this.set_width();
        t2 = new Date().getTime();
        //console.logset_width 消耗：' + (t2 - t1));
        t1 = new Date().getTime();
        this.make_bars_title();
        t2 = new Date().getTime();
        //console.logmake_bars_title 消耗：' + (t2 - t1));

        t1 = new Date().getTime();
        this.set_Xscroll();
        t2 = new Date().getTime();
        //console.logset_Xscroll 消耗：' + (t2 - t1));
        t1 = new Date().getTime();
        this.set_Render();
        t2 = new Date().getTime();
        //console.logRangeRender 消耗：' + (t2 - t1));
        t1 = new Date().getTime();
        this.set_scroll_position();
        t2 = new Date().getTime();
        //console.logset_scroll_position 消耗：' + (t2 - t1));
    }

    set_Render() {
        if (!this.xRender) this.xRender = new Xrender(this);
    }

    getTextWidth(text, font = ' normal 12px verdana  ') {
        let canvas =
            this.canvas || (this.canvas = document.createElement('canvas'));
        let context = canvas.getContext('2d');
        context.font = font;
        let metrics = context.measureText(text);
        return metrics.width;
    }

    //判断当前bar的标题是否与其他的重叠
    isInBarTitleRange(bar) {
        let that = this;
        let inRange = function (rang1, rang2) {
            if (rang1.x2 >= rang2.x1) {
                return false;
            }
            return true;
        };

        let getPosition = function (bartmp) {
            if (bartmp.x1) return bartmp;

            bartmp.x1 = bartmp.x + 5; // + bartmp.progress_width / 2;
            if (bartmp.task.name) {
                if (bartmp.task.name.hasOwnProperty('nickname')) {
                    //因为头像的问题
                    // bartmp.x1 -= 30;
                    //因为头像的占位 要变长
                    bartmp.x2 =
                        bartmp.x1 +
                        26 +
                        that.getTextWidth(bartmp.task.name.nickname) +
                        10;
                } else
                    bartmp.x2 =
                    bartmp.x1 + that.getTextWidth(bartmp.task.name) + 10;
            }
            return bartmp;
        };
        bar = getPosition(bar);

        let sc = this.barsArrays.indexOf(bar.task.id);
        let n = this.barsArrays.length;
        for (let c = sc + 1; c < n; c++) {
            let items = this.barsMaps[this.barsArrays[c]];
            // 不是同一行数据，忽略
            if (items.task.id == bar.task.id) continue;
            if (items.y != bar.y) continue;

            items = getPosition(items);
            const ret = inRange(bar, items);
            // console.log(...['bar',bar.task.name,bar.x1,bar.x2])
            // console.log(...['items',items.task.name,items.x1,items.x2])
            if (!ret) {
                //console.logbar ', bar.task.name.nickname, bar.x1, bar.x2);
                // console.log(
                //     'items ',
                //     items.task.name.nickname,
                //     items.x1,
                //     items.x2
                // );
                let width = items.x2 - items.x1;
                items.x1 = bar.x2;
                items.x2 = items.x1 + width;
                //如果同一行的任务过多，超出范围的部分在边框附件重叠 
                if (items.x2 >= that.cur_width) {
                    items.x2 = that.cur_width - 10;
                    items.x1 = that.cur_width - 10 - width;
                }
                this.barsMaps[this.barsArrays[c]] = items;
                //console.log -----------end-------------- ');
                // console.log(
                //     'items ',
                //     items.task.name.nickname,
                //     items.x1,
                //     items.x2
                // );
            }
            // console.log(...['items1',items.task.name,items.x1,items.x2]);
        }
        return bar;
    }

    makeMast(x, y, r, taskId, root) {
        let mask = createSVG('mask', {
            id: 'mask-' + this.gantt_id + taskId,
            append_to: root
        });
        createSVG('circle', {
            cx: x + r,
            cy: y + r,
            r: r,
            fill: 'white',
            filter: 'url(#filter)',
            append_to: mask
        });
    }

    //绘制标题的图标
    renderTaskTitleIcon(t, x, y, root, bar) {
        if (t.match(/^[\u4e00-\u9fa5]+$/)) {
            t = t.substr(t.length - 1 > 0 ? t.length - 1 : 0, 1);
        } else {
            t = t.substr(0, 1);
        }
        let obj = {
            color: t.charCodeAt(0) % 6,
            name: t.toUpperCase()
        };

        createSVG('circle', {
            cx: x + 10,
            cy: y + 10,
            r: 10,
            class: 'bar-label bar-icon color-' + obj.color,
            'data-id': bar.task.id,
            'data-legend': bar.legendBase64,
            append_to: root
        });

        createSVG('text', {
            x: x + 10,
            y: y + 11,
            innerHTML: obj.name,
            class: 'bar-label bar-icon-text',
            style: 'dominant-baseline:middle;text-anchor:middle;',
            'data-id': bar.task.id,
            'data-legend': bar.legendBase64,
            append_to: root
        });
    }

    make_bars_title() {
        let that = this;
        let defs = createSVG('defs', {
            append_to: this.$svg
        });
        let filter = createSVG('filter', {
            id: 'filter',
            append_to: defs
        });
        createSVG('feGaussianBlur', {
            stdDeviation: '0',
            append_to: filter
        });
        let imageOffsetTop = 3;
        let n = this.barsArrays.length;
        for (let c = 0; c < n; c++) {
            let bar = this.barsMaps[this.barsArrays[c]];
            // console.log(bar);
            bar = this.isInBarTitleRange(bar);
            // this.barsMaps[c].x = bar.x;
            let title = bar.task.name;
            if (bar.task.name) {
                if (bar.task.name.hasOwnProperty('nickname')) {
                    if (bar.task.name.src) {
                        that.makeMast(
                            bar.x1,
                            bar.y + imageOffsetTop,
                            10,
                            bar.task.id,
                            defs
                        );
                        let image = createSVG('image', {
                            x: bar.x1,
                            y: bar.y + imageOffsetTop,
                            width: 20,
                            height: 20,
                            href: bar.task.name.src,
                            mask: 'url(#mask-' +
                                that.gantt_id +
                                bar.task.id +
                                ')',
                            class: 'bar-label',
                            'data-id': bar.task.id,
                            'data-legend': bar.legendBase64,
                            append_to: this.layers.barsTitle
                        });

                        createSVG('circle', {
                            cx: bar.x1 + 10,
                            cy: bar.y + imageOffsetTop + 10,
                            r: 10,
                            class: 'bar-label bar-icon',
                            'data-id': bar.task.id,
                            'data-legend': bar.legendBase64,
                            append_to: this.layers.barsTitle
                        });

                        bar.x1 += 26;
                        $.on(
                            image,
                            'focus ' + this.options.popup_trigger,
                            e => {
                                if (bar.action_completed) {
                                    // just finished a move action, wait for a few seconds
                                    return;
                                }
                                if (e.changedTouches) {
                                    let touchm = e.changedTouches[0];
                                    bar.elX = touchm.clientX || touchm.pageX;
                                    bar.elY = touchm.clientY || touchm.pageY;
                                }
                                bar.show_popup();
                                this.unselect_all();
                                bar.group.classList.add('active');
                            }
                        );
                        $.on(image, 'click', e => {
                            if (bar.action_completed) {
                                // just finished a move action, wait for a few seconds
                                return;
                            }
                            this.trigger_event('click', [bar.task]);
                        });
                    } else {
                        // x: bar.x1,
                        // y: bar.y + imageOffsetTop,
                        //根据 nickname 创建 圆型图标
                        if (bar.task.name.nickname) {
                            that.renderTaskTitleIcon(
                                bar.task.name.nickname,
                                bar.x1,
                                bar.y + imageOffsetTop,
                                that.layers.barsTitle,
                                bar
                            );
                            bar.x1 += 26;
                        }
                    }
                    if (bar.task.name.nickname) title = bar.task.name.nickname;
                    else title = '';
                }
            }

            let text = createSVG('text', {
                x: bar.x1,
                y: bar.y + bar.height / 2 - 1,
                innerHTML: title,
                class: 'bar-label',
                'data-id': bar.task.id,
                'data-legend': bar.legendBase64,
                style: "font-weight:500;-webkit-filter:brightness(0.5);-o-filter:brightness(0.5);-moz-filter:brightness(0.5);filter:brightness(0.5);fill:" + bar.task.color + ' ;',
                append_to: this.layers.barsTitle
            });

            $.on(text, 'focus ' + this.options.popup_trigger, e => {
                if (bar.action_completed) {
                    // just finished a move action, wait for a few seconds
                    return;
                }
                if (e.changedTouches) {
                    let touchm = e.changedTouches[0];
                    bar.elX = touchm.clientX || touchm.pageX;
                    bar.elY = touchm.clientY || touchm.pageY;
                }
                bar.show_popup();
                this.unselect_all();
                bar.group.classList.add('active');
            });
            $.on(text, 'click', e => {
                if (bar.action_completed) {
                    // just finished a move action, wait for a few seconds
                    return;
                }
                this.trigger_event('click', [bar.task]);
            });
            //barsTitle
        }
    }

    setup_layers() {
        this.layers = {};
        // const layers = ['grid', 'date', 'arrow', 'progress', 'bar', 'details'];
        const layers = [
            'grid',
            'arrow',
            'progress',
            'bar',
            'details',
            'barsTitle'
        ];
        // make group layers
        for (let layer of layers) {
            this.layers[layer] = createSVG('g', {
                class: layer,
                append_to: this.$svg
            });
        }

        this.layers['date'] = createSVG('g', {
            class: 'date',
            append_to: this.$svg_header
        });
    }

    make_grid() {
        this.make_grid_background();
        this.make_grid_rows();
        // this.make_grid_header();
        this.make_grid_ticks();
        this.make_grid_highlights();
    }

    make_grid_background() {
        const grid_width = this.dates.length * this.options.column_width;
        const grid_height =
            (this.options.bar_height + this.options.padding) *
            this.tasks.length;

        createSVG('rect', {
            x: 0,
            y: 0,
            width: grid_width,
            height: grid_height,
            class: 'grid-background',
            append_to: this.layers.grid
        });

        $.attr(this.$svg, {
            height: grid_height,
            width: '100%'
        });
    }

    make_grid_rows() {
        const rows_layer = createSVG('g', {
            append_to: this.layers.grid
        });
        const lines_layer = createSVG('g', {
            append_to: this.layers.grid
        });

        const row_width = this.dates.length * this.options.column_width;
        const row_height = this.options.bar_height + this.options.padding;

        let row_y = 0; //this.options.padding / 2;
        for (let task of this.tasks) {
            createSVG('rect', {
                x: 0,
                y: row_y,
                width: row_width,
                height: row_height,
                class: 'grid-row',
                append_to: rows_layer
            });

            createSVG('line', {
                x1: 0,
                y1: row_y + row_height,
                x2: row_width,
                y2: row_y + row_height,
                class: 'row-line',
                append_to: lines_layer
            });

            row_y += this.options.bar_height + this.options.padding;
        }
        createSVG('line', {
            x1: 0,
            y1: row_y,
            x2: row_width,
            y2: row_y,
            class: 'row-line',
            append_to: lines_layer
        });
    }

    make_grid_header() {
        const header_width = this.dates.length * this.options.column_width;
        createSVG('rect', {
            x: 0,
            y: 0,
            width: header_width,
            height: 0,
            class: 'grid-header',
            append_to: this.layers.grid
        });
    }

    make_grid_ticks() {
        let tick_x = this.options.column_width;
        let tick_y = 0; //this.options.padding / 2;
        let tick_height =
            (this.options.bar_height + this.options.padding) *
            this.tasks.length;

        for (let date of this.dates) {
            let tick_class = 'tick';
            // thick tick for monday
            if (this.view_is(VIEW_MODE.DAY) && date.getDate() === 1) {
                tick_class += ' thick';
            }
            // thick tick for first week
            if (
                this.view_is(VIEW_MODE.WEEK) &&
                date.getDate() >= 1 &&
                date.getDate() < 8
            ) {
                tick_class += ' thick';
            }
            // thick ticks for quarters
            if (this.view_is(VIEW_MODE.MONTH)) {
                if ((date.getMonth() + 1) % 3 === 0) tick_class += ' thick';

                let day = date_utils.get_days_in_month(date);
                switch (day) {
                    case 31:
                        tick_x += this.options.column_width / 30;
                        break;
                    case 29:
                        tick_x -= this.options.column_width / 30;
                        break;
                    case 28:
                        tick_x -= this.options.column_width / 30 * 2;
                        break;
                }
            }
            if (this.view_is(VIEW_MODE.Quarterly_Month)) {
                let day = date_utils.get_days_in_month(date);
                switch (day) {
                    case 31:
                        tick_x += this.options.column_width / 30;
                        break;
                    case 29:
                        tick_x -= this.options.column_width / 30;
                        break;
                    case 28:
                        tick_x -= this.options.column_width / 30 * 2;
                        break;
                }
            }

            createSVG('path', {
                d: `M ${tick_x} ${tick_y} v ${tick_height}`,
                class: tick_class,
                append_to: this.layers.grid
            });

            // if (this.view_is(VIEW_MODE.MONTH)) {
            //     tick_x +=
            //         date_utils.get_days_in_month(date) *
            //         this.options.column_width /
            //         30;
            // } else
            {
                tick_x += this.options.column_width;
            }
        }
    }

    make_grid_highlights() {
        // highlight today's date
        let x = -1;
        let y = 0;
        let width = this.options.column_width;
        let height =
            (this.options.bar_height + this.options.padding) *
            this.tasks.length +
            0; //this.options.padding / 2;
        if (this.view_is([VIEW_MODE.HOUR])) {
            x =
                date_utils.diff(date_utils.now(), this.gantt_start, 'hour') *
                this.options.column_width;
        }
        if (this.view_is([VIEW_MODE.HALF_DAY])) {
            x =
                date_utils.diff(date_utils.today(), this.gantt_start, 'hour') /
                12 *
                this.options.column_width;
            if (date_utils.now().getHours() > 12) {
                x += this.options.column_width;
            }
        }
        if (this.view_is([VIEW_MODE.DAY, VIEW_MODE.WEEK])) {
            x =
                date_utils.diff(date_utils.today(), this.gantt_start, 'hour') /
                this.options.step *
                this.options.column_width;
        }
        // if (this.view_is([VIEW_MODE.Quarterly_Month])) {
        //     let date = new Date();
        //     x = date_utils.diff(
        //         new Data(...[date.getFullYear(), date.getMonth(), 0]),
        //         this.gantt_start,
        //         'hour' * this.options.column_size
        //     );
        // }
        if (this.view_is([VIEW_MODE.MONTH, VIEW_MODE.Quarterly_Month])) {
            let date1 = new Date();
            x = date_utils.diff(
                new Date(date1.getFullYear(), date1.getMonth(), 1),
                this.gantt_start,
                'hour'
            ) * this.options.column_size;
            let day = date_utils.get_days_in_month(date1);
            width = day * 24 * this.options.column_size;
        }
        if (this.view_is([VIEW_MODE.QUARTERLY])) {
            x =
                Math.floor(date_utils.diff(date_utils.today(), this.gantt_start, 'month') / 3) * this.options.column_width;
        }
        if (this.view_is([VIEW_MODE.YEAR])) {
            x =
                Math.floor(date_utils.diff(date_utils.today(), this.gantt_start, 'month') / 6) * this.options.column_width;
        }
        if (x > -1) {
            createSVG('rect', {
                x,
                y,
                width,
                height,
                class: 'today-highlight',
                append_to: this.layers.grid
            });
        }
    }

    // 根据滚动条自动调整位置
    upper_date_automove(x) {
        let offset = Math.abs(x); //当前屏幕位置
        if (isNaN(offset)) offset = 0;
        // if(x == )
        this.tasksOffset = offset;
        this.layers.bar.setAttribute(
            'transform',
            'translate(' + -offset + ',0)'
        );
        this.layers.barsTitle.setAttribute(
            'transform',
            'translate(' + -offset + ',0)'
        );
        this.layers.arrow.setAttribute(
            'transform',
            'translate(' + -offset + ',0)'
        );

        if (!this.XscrollTask) return;

        let scrollx = this.tasksOffset;
        let scrollxEnd = scrollx + this.$task_content.offsetWidth; //可见宽度
        let Intervals = [];
        const len = this.datetick.length;
        for (let i = 0; i < len; i++) {
            const Interval = this.datetick[i];
            // console.log(Interval.x1 + this.options.column_width, scrollxEnd)
            if (
                Interval.x1 >= scrollx - this.options.column_width &&
                Interval.x1 + this.options.column_width <=
                scrollxEnd + this.options.column_width
            ) {
                Intervals.push(Object.assign({}, Interval));
            }
        }
        // console.log(Intervals)
        // let t1 = new Date().getTime();
        this.xRender.render(scrollx, Intervals);
        // let t2 = new Date().getTime();
        // //console.logthis.xRender.render 消耗：' + (t2 - t1));
        //this.datetick

        // if (
        //     this.view_is([
        //         VIEW_MODE.HALF_DAY,
        //         VIEW_MODE.WEEK,
        //         'Quarterly Month',
        //         'Year'
        //     ])
        // )
    }

    make_dates() {
        this.upper_datas = [];
        let t1 = new Date().getTime();
        //时间刻度
        this.datetick = this.get_dates_to_draw();
        let t2 = new Date().getTime();
        //console.logget_dates_to_draw 消耗：' + (t2 - t1));
        this.cur_width = this.datetick.length * this.options.column_width;
        //console.log------this.cur_width------', this.cur_width);
        return;
    }

    get_dates_to_draw() {
        let last_date = null;
        const dates = this.dates.map((date, i) => {
            const d = this.get_date_info(date, last_date, i);
            last_date = date;
            return d;
        });
        return dates;
    }

    // //计算 季度结束的月份
    get_Quarterly_endmonth(date) {
        let month = date.getMonth();
        if (month >= 0 && month <= 2) {
            return new Date(...[date.getFullYear(), 3, 1]);
        }
        if (month >= 3 && month <= 5) {
            return new Date(...[date.getFullYear(), 6, 1]);
        }
        if (month >= 6 && month <= 8) {
            return new Date(...[date.getFullYear(), 9, 1]);
        }
        if (month >= 9 && month <= 11) {
            return new Date(...[date.getFullYear() + 1, 0, 1]);
        }
    }

    get_date_info(date, last_date, i) {
        if (!last_date) {
            last_date = date_utils.add(date, 13, 'month');
        }
        const base_pos = {
            x: i * this.options.column_width,
            lower_y: 58,
            upper_y: 24
        };

        const x_pos = {
            Hour_lower: this.options.column_width / 2,
            Hour_upper: this.options.column_width * 24 / 2,
            'Quarter Day_lower': 0,
            'Quarter Day_upper': this.options.column_width * 4 / 2,
            'Half Day_lower': this.options.column_width / 2,
            'Half Day_upper': this.options.column_width * 2 / 2,
            Day_lower: this.options.column_width / 2,
            Day_upper: this.options.column_width * 30 / 2,
            Week_lower: this.options.column_width / 2,
            Week_upper: this.options.column_width * 7 / 2,
            Month_lower: this.options.column_width / 2,
            Month_upper: this.options.column_width * (12 - date.getMonth()) / 2,
            Year_lower: this.options.column_width / 2,
            Year_upper: this.options.column_width,
            Quarterly_lower: this.options.column_width / 2,
            Quarterly_upper: this.options.column_width * 2,
            Quarterly_right: this.options.column_width * 2,
            'Quarterly Month_lower': this.options.column_width / 2,
            'Quarterly Month_upper': this.options.column_width + this.options.column_width / 2,
        };

        let date_text = {};
        switch (this.options.view_mode) {
            case 'Year': {
                date_text = {
                    Year_lower: date_utils.format(
                        date,
                        'YYYYTT',
                        this.options.language
                    ),
                    Year_upper: date.getFullYear()
                };
                if (date_text.Year_upper)
                    x_pos['Year_upper_right'] = this.options.column_width * 2;
                x_pos['Year_upper'] = this.options.column_width;
                break;
            }
            case 'Quarterly': {
                date_text = {
                    Quarterly_lower: date_utils.format(
                        date,
                        'YYYYQ',
                        this.options.language
                    ),
                    Quarterly_upper: date.getFullYear()
                };
                // let offset = 4 - Math.floor(date.getMonth() / 3);
                // if (date_text.Quarterly_upper)
                //     x_pos['Quarterly_upper_right'] =
                //         this.options.column_width * offset;
                x_pos['Quarterly_upper'] =
                    x_pos['Quarterly_upper_right'] / 2;
            }
            break;
        case VIEW_MODE.Quarterly_Month: {
            date_text = {
                'Quarterly Month_lower': date_utils.format(
                    date,
                    'MM',
                    this.options.language
                ),
                'Quarterly Month_upper': date_utils.format(date, 'YYYY,YYYYQ', this.options.language)
            };
            let offset = 3 - date.getMonth() % 3;
            // x_pos['Quarterly Month_upper_right'] =
            //     this.options.column_width * offset;
            x_pos['Quarterly Month_upper'] = this.options.column_width * offset / 2;

            // let hour = date_utils.diff(date, this.gantt_start, 'hour');
            // base_pos.x = hour * this.options.column_size;
            // if (date_text['Quarterly Month_upper']) {
            //     let newdate = this.get_Quarterly_endmonth(date);

            //     // let newdate = new Date(...[date.getFullYear() + 1, 0, 1]);
            //     let upperHoures = date_utils.diff(
            //         newdate,
            //         this.gantt_start,
            //         'hour'
            //     );
            //     x_pos['Quarterly Month_upper_right'] =
            //         upperHoures * this.options.column_size - base_pos.x;
            // }
            break;
        }
        case 'Month': {
            date_text = {
                Month_lower: date_utils.format(date, 'MM', this.options.language),
                Month_upper: date_utils.format(date, 'YYYY', this.options.language)
            };
            // let hour = date_utils.diff(date, this.gantt_start, 'hour');
            // base_pos.x = hour * this.options.column_size;
            // if (date_text.Month_upper) {
            //     let newdate = new Date(...[date.getFullYear() + 1, 0, 1]);
            //     let upperHoures = date_utils.diff(
            //         newdate,
            //         this.gantt_start,
            //         'hour'
            //     );
            //     x_pos.Month_upper_right =
            //         upperHoures * this.options.column_size - base_pos.x;
            // }
            break;
        }
        case 'Week': {
            date_text = {
                Week_lower: date_utils.format(
                    date,
                    'w',
                    this.options.language
                ),
                Week_upper: date_utils.format(
                    date,
                    'YYYY-MM-D',
                    this.options.language
                )
            };
            // if (date_text.Week_upper && date.getDay() != 1)
            //     date_text.Week_upper = '';
            // if (date_text.Week_upper) {
            //     x_pos.Week_upper_right = this.options.column_width * 7;
            //     let week = date.getDay();
            //     switch (week) {
            //         case 0:
            //             x_pos.Week_upper_right = this.options.column_width * 7;
            //         default:
            //             x_pos.Week_upper_right = this.options.column_width * (8 - week);
            //     }
            // }
            break;
        }

        case 'Day': {
            date_text = {
                Day_lower: date_utils.format(
                    date,
                    'D',
                    this.options.language
                ),
                Day_upper: date_utils.format(date, 'YYYY-MM', this.options.language)
            }
            // if (date_text.Day_upper) {

            //     //日期模式的 右侧边框线
            //     let day = date_utils.get_days_in_month(
            //         new Date(
            //             ...[
            //                 date.getFullYear(),
            //                 date.getMonth(),
            //                 date.getDate()
            //             ]
            //         )
            //     );
            //     let offset = day;
            //     if (date.getDate() != 1) {
            //         offset = day - date.getDate() + 1;
            //     }
            //     if (offset < 3) {
            //         date_text.Day_upper = '';
            //     }
            //     x_pos.Day_upper_right = this.options.column_width * offset;
            //     x_pos.Day_upper = x_pos.Day_upper_right / 2;
            // }
            break;
        }
        case 'Half Day': {
            date_text = {
                'Half Day_lower': date_utils.format(
                    date,
                    'TT',
                    this.options.language
                ),
                'Half Day_upper': date_utils.format(
                    date,
                    'MM-D',
                    this.options.language
                )
            };
            if (date_text['Half Day_upper']) {
                x_pos.Day_upper_right = this.options.column_width * 2;
                x_pos.Day_upper = x_pos.Day_upper_right / 2;
            }
            break;
        }
        case 'Hour': {
            date_text = {
                Hour_lower: date_utils.format(
                    date,
                    'HH:00',
                    this.options.language
                ),
                Hour_upper: date_utils.format(
                    date,
                    'YYYY-MM-D',
                    this.options.language
                )
            };
            if (date_text['Half Day_upper']) {
                x_pos.Day_upper_right = this.options.column_width * 24;
                x_pos.Day_upper = x_pos.Day_upper_right / 2;
            }
            break;
        }
        }
        return {
            upper_text: date_text[`${this.options.view_mode}_upper`],
            lower_text: date_text[`${this.options.view_mode}_lower`],
            upper_x: base_pos.x + x_pos[`${this.options.view_mode}_upper`],
            upper_x1: base_pos.x + x_pos[`${this.options.view_mode}_upper_right`],
            upper_y: base_pos.upper_y,
            lower_x: base_pos.x + x_pos[`${this.options.view_mode}_lower`],
            lower_y: base_pos.lower_y,
            x1: base_pos.x +
                x_pos[`${this.options.view_mode}_lower`] -
                (x_pos[`${this.options.view_mode}_lower`] ||
                    this.options.padding),
            lower_padding: x_pos[`${this.options.view_mode}_lower`] ||
                this.options.padding,
            upper_padding: x_pos[`${this.options.view_mode}_upper`] || this.options.padding,
            week: date.getDay(),
            date: date
        };
    }

    make_bars() {
        this.bars = {};
        this.barsMaps = {};
        this.barsArrays = [];
        this.dependencieMaps = {};
        // this.bars =
        this.tasks.map(task => {
            if (!task.invalid) {
                const bar = new Bar(this, task);
                this.bars[task._index] = bar;
                this.barsMaps[task.id] = bar;
                this.barsArrays.push(task.id);
                this.dependencieMaps[task.dependencieId] = bar;
                this.layers.bar.appendChild(bar.group);
            }

            if (task.hasOwnProperty('datas')) {
                let len = task.datas.length;
                for (let index = 0; index < len; index++) {
                    if (!task.datas[index].invalid) {
                        const bar1 = new Bar(this, task.datas[index]);
                        // task.datas[index]._index =
                        //     task._index + '00000000' + task.datas[index]._index;
                        this.dependencieMaps[task.datas[index].dependencieId] = bar1;
                        this.barsMaps[task.datas[index].id] = bar1;
                        this.barsArrays.push(task.datas[index].id);
                        this.layers.bar.appendChild(bar1.group);
                    }
                }
            }

            // return bar;
        });
    }

    // 多级任务节点
    make_single_arrows(task) {
        task.dependencies
            .map(task_id => {
                const dependency = this.get_task(task_id);
                // 没找到来源
                if (!dependency) return;
                // 同级来源
                if (dependency.dependencieId === task.dependencieId) return;

                if(!this.dependencieMaps[dependency.dependencieId] || !this.dependencieMaps[task.dependencieId]) return


                const arrow = new Arrow(
                    this,
                    this.dependencieMaps[dependency.dependencieId], // from_task
                    this.dependencieMaps[task.dependencieId] // to_task
                );
                this.layers.arrow.appendChild(arrow.element);
                return arrow;
            })
            .filter(Boolean); // filter falsy values
        // this.arrows = this.arrows.concat(arrows);
    }
    make_arrows() {
        //绘制关联关系
        this.arrows = [];
        for (let task of this.tasks) {
            if (task.invalid) return;
            this.make_single_arrows(task);
            if (task.hasOwnProperty('datas')) {
                let len = task.datas.length;
                for (let index = 0; index < len; index++) {
                    if (task.datas[index].invalid) continue;
                    this.make_single_arrows(task.datas[index]);
                }
            }
        }
    }

    map_arrows_on_bars() {
        for (let i in this.bars) {
            let bar = this.bars[i];
            if (!bar) return;
            bar.arrows = this.arrows.filter(arrow => {
                return (
                    arrow.from_task.task.id === bar.task.id ||
                    arrow.to_task.task.id === bar.task.id
                );
            });
        }
    }

    set_width() {
        this.line_height = this.options.bar_height + this.options.padding;
        this.tick_height = this.line_height * this.tasks.length;

        this.$svg.setAttribute('width', this.$task.offsetWidth);
        this.$svg_header.setAttribute('width', this.$task.offsetWidth);

        this.$svg_data_header.setAttribute('height', 74);
        this.$svg_header.setAttribute('height', 74);
        this.$svg.setAttribute('height', this.tick_height);
    }

    set_scroll_position() {
        let that = this;
        let t1 = new Date().getTime();
        const parent_element = this.$svg.parentElement || this.$svg.parentNode;
        if (!parent_element) return;
        let t2 = new Date().getTime();
        //console.logset_scroll_position 111 消耗：' + (t2 - t1));
        let view_mode = 'hour';
        switch (this.options.view_mode) {
            case 'Year':
            case 'Day':
            case 'Week':
            case 'Quarterly': {
                view_mode = 'day';
                break;
            }
            case 'Half Day':
            case 'Hour':
            case 'Month':
            case VIEW_MODE.Quarterly_Month:
                view_mode = 'hour';
                break;
        }
        t1 = new Date().getTime();
        const hours_before_first_task = date_utils.diff(
            this.get_oldest_starting_date(),
            this.gantt_start,
            view_mode
        );
        t2 = new Date().getTime();
        //console.logset_scroll_position 222 消耗：' + (t2 - t1));
        t1 = new Date().getTime();
        let scroll_pos =
            hours_before_first_task /
            this.options.step *
            this.options.column_width -
            this.options.column_width;
        t2 = new Date().getTime();
        //console.logset_scroll_position 333 消耗：' + (t2 - t1));
        t1 = new Date().getTime();
        switch (this.options.view_mode) {
            case 'Year': {
                scroll_pos =
                    hours_before_first_task *
                    this.options.column_width /
                    365 *
                    2 -
                    this.options.column_width;
                break;
            }
            case 'Day':
            case 'Week': {
                if (hours_before_first_task >= 2) {
                    scroll_pos =
                        (hours_before_first_task - 1) *
                        this.options.column_width -
                        this.options.column_width;
                }
                break;
            }
            case 'Quarterly': {
                scroll_pos =
                    hours_before_first_task *
                    this.options.column_width /
                    365 *
                    4 -
                    this.options.column_width;
                break;
            }
        }
        t2 = new Date().getTime();
        //console.logset_scroll_position 444 消耗：' + (t2 - t1));
        t1 = new Date().getTime();
        if (scroll_pos <= 0) scroll_pos = 0;

        let scrollx = parseFloat(
            this.$task_content_shell.style.marginLeft || 0
        );
        if (scrollx != 0) {
            this.set_Xscroll();
        } else {
            if (scroll_pos > this.options.column_width) {
                this.upper_date_automove(
                    -scroll_pos + this.options.column_width
                );
            } else {
                this.upper_date_automove(0);
            }
        }
        t2 = new Date().getTime();
        //console.logset_scroll_position 555 消耗：' + (t2 - t1));
    }

    bind_grid_click() {
        if (this.options.popup_trigger)
            $.on(this.$svg, this.options.popup_trigger, '.grid', () => {
                this.unselect_all();
                this.hide_popup();
            });
    }

    bind_container_events() {
        let that = this;
        let mousedrag = false;
        let mousedragx = 0;
        let scrollx = 0;
        let mousedragy = 0;
        let scrolly = 0;
        let mousedown = function (event) {
            let e = event;
            if (event.changedTouches) e = event.changedTouches[0];
            let box = that.$taskinfo_content.getBoundingClientRect();
            that.contentTop = box.top;
            that.contentLeft = box.left;

            mousedrag = true;
            mousedragx = e.clientX;
            mousedragy = e.clientY;
            scrollx = -that.tasksOffset || 0;
            scrolly = parseFloat(that.$task_content_shell.style.marginTop || 0);
            let mouseup = function (e) {
                mousedrag = false;
                mousedragx = 0;
                document.removeEventListener('mouseup', mouseup, false);
                document.removeEventListener('touchend', mouseup, false);
            };
            document.addEventListener('mouseup', mouseup, false);
            document.addEventListener('touchend', mouseup, false);
            event.preventDefault();
            event.stopPropagation();
            return false;
        };
        that.$container.addEventListener('mousedown', mousedown, false);
        that.$container.addEventListener('touchstart', mousedown, false);
        let c = function (e) {
            if (mousedrag) {
                if (e.clientX > 0) {
                    // 防止内容拖动 与滚动条拖动同时触发生产的 抖动的情况
                    // console.log(e.currentTarget);
                    let ss = e.clientX - mousedragx;
                    let ssy = e.clientY - mousedragy;
                    let pos = scrollx + ss;
                    let posy = scrolly + ssy;
                    // console.log(scrollx, ss);
                    if (that.XscrollTask.biliX <= 1) {
                        pos = 0;
                    } else {
                        if (pos > 0) {
                            pos = 0;
                        } else {
                            pos = that.XscrollTask.isScrollXEnd(pos);
                        }
                    }
                    if (that.XscrollTask.bili <= 1) {
                        posy = 0;
                    } else {
                        if (posy > 0) {
                            posy = 0;
                        } else {
                            posy = that.XscrollTask.isScrollYEnd(posy)
                        }
                    }

                    //数据信息 左侧
                    that.$taskinfo_content_svgshell.style.marginTop =
                        posy + 'px';
                    //任务进度内容
                    that.$task_content_shell.style.marginTop = posy + 'px';
                    that.upper_date_automove(pos);
                    //同步滚动条位置
                    that.XscrollTask.setScrollmargin({
                        marginTop: posy,
                        marginLeft: pos
                    });

                    that.XscrollInfo.setScrollmargin({
                        marginTop: posy
                    });
                }
            }
        };
        that.$container.addEventListener(
            'mousemove',
            that.debounce(function (event) {
                let e = event;
                if (event.changedTouches) e = event.changedTouches[0];
                c(e);
                event.preventDefault();
                event.stopPropagation();
                return false;
            }, 5),
            false
        );
        that.$container.addEventListener(
            'touchmove',
            that.debounce(function (event) {
                let e = event;
                if (event.changedTouches) e = event.changedTouches[0];
                c(e);
                event.preventDefault();
                event.stopPropagation();
                return false;
            }, 5),
            false
        )
    }

    report_task_pos(pos, posy) {
        let that = this;
        if (that.XscrollInfo.biliX <= 1) {
            pos = 0;
        } else {
            if (pos > 0) {
                pos = 0;
            } else {
                pos = that.XscrollInfo.isScrollXEnd(pos);
            }
        }
        if (that.XscrollTask.bili <= 1) {
            posy = 0;
        } else {
            if (posy > 0) {
                posy = 0;
            } else {
                posy = that.XscrollInfo.isScrollYEnd(posy);
            }
        }

        that.$task_content_shell.style.marginTop = posy + 'px';
        that.$taskinfo_content_svgshell.style.marginTop = posy + 'px';
        that.$taskinfo_content_svgshell.style.marginLeft = pos + 'px';
        that.$svg_data_header_shell.style.marginLeft = pos + 'px';
        that.XscrollInfo.setScrollmargin({
            marginTop: posy,
            marginLeft: pos
        });
        that.XscrollTask.setScrollmargin({
            marginTop: posy
        });
    }

    bind_taskinfo_events() {
        let that = this;
        let mousedrag = false;
        let mousedragx = 0;
        let scrollx = 0;
        let mousedragy = 0;
        let scrolly = 0;

        let mousedown = function (event) {
            let e = event;
            if (event.changedTouches) e = event.changedTouches[0];
            let box = that.$taskinfo_content.getBoundingClientRect();
            that.contentTop = box.top;
            that.contentLeft = box.left;
            mousedrag = true;
            mousedragx = e.clientX;
            mousedragy = e.clientY;
            scrollx = parseFloat(
                that.$taskinfo_content_svgshell.style.marginLeft || 0
            );
            scrolly = parseFloat(
                that.$taskinfo_content_svgshell.style.marginTop || 0
            );
            let mouseup = function (e) {
                mousedrag = false;
                mousedragx = 0;
                document.removeEventListener('mouseup', mouseup, false);
                document.removeEventListener('touchend', mouseup, false);
            };
            document.addEventListener('mouseup', mouseup, false);
            document.addEventListener('touchend', mouseup, false);
            event.preventDefault();
            event.stopPropagation();
            return false;
        };
        that.$taskinfo_content_svgshell.addEventListener(
            'mousedown',
            mousedown,
            false
        );
        that.$taskinfo_content_svgshell.addEventListener(
            'touchstart',
            mousedown,
            false
        );

        let c = function (e) {
            if (mousedrag) {
                if (e.clientX > 0) {
                    // console.log(e.currentTarget);
                    let ss = e.clientX - mousedragx;
                    let ssy = e.clientY - mousedragy;
                    let pos = scrollx + ss;
                    let posy = scrolly + ssy;
                    that.report_task_pos(pos, posy);
                }
            }
        }

        that.$taskinfo_content.addEventListener(
            'mousemove',
            that.debounce(function (event) {
                let e = event;
                if (event.changedTouches) e = event.changedTouches[0];
                c(e);
                event.preventDefault();
                event.stopPropagation();
                return false;
            }, 2),
            false
        );
        that.$taskinfo_content.addEventListener(
            'touchmove',
            that.debounce(function (event) {
                let e = event;
                if (event.changedTouches) e = event.changedTouches[0];
                c(e);
                event.preventDefault();
                event.stopPropagation();
                return false;
            }, 2),
            false
        );
    }

    set_Xscroll() {
        let that = this;
        if (!this.XscrollInfo)
            this.XscrollInfo = new Xscroll(that.$taskinfo_content_svgshell, {
                'overflow-y': !1,
                onChangeY: that.debounce(function (e) {
                    that.$task_content_shell.style.marginTop = -e + 'px';
                    that.XscrollTask.setScrollmargin({
                        marginTop: 0 - e
                    });
                }, 2),
                onChangeX: that.debounce(function (e) {
                    that.$svg_data_header_shell.style.marginLeft = -e + 'px';
                }, 2)
            });
        else this.XscrollInfo.refresh();

        if (!this.XscrollTask)
            this.XscrollTask = new Xscroll(that.$task_content_shell, {
                elementWidth: that.cur_width,
                onChangeY: that.debounce(function (e) {
                    that.$taskinfo_content_svgshell.style.marginTop = -e + 'px';

                    that.XscrollInfo.setScrollmargin({
                        marginTop: -e
                    });
                }, 5),
                onChangeX: that.debounce(function (e) {
                    that.upper_date_automove(-e);
                }, 5)
            });
        else {
            this.XscrollTask.refresh({
                elementWidth: this.cur_width
            });
        }
    }

    bind_bar_events() {
        let is_dragging = false;
        let x_on_start = 0;
        let y_on_start = 0;
        let is_resizing_left = false;
        let is_resizing_right = false;
        let parent_bar_id = null;
        let bars = []; // instanceof Bar
        this.bar_being_dragged = null;

        function action_in_progress() {
            return is_dragging || is_resizing_left || is_resizing_right;
        }

        $.on(this.$svg, 'mousedown', '.bar-wrapper, .handle', (e, element) => {
            const bar_wrapper = $.closest('.bar-wrapper', element);

            if (element.classList.contains('left')) {
                is_resizing_left = true;
            } else if (element.classList.contains('right')) {
                is_resizing_right = true;
            } else if (element.classList.contains('bar-wrapper')) {
                is_dragging = true;
            }

            bar_wrapper.classList.add('active');

            x_on_start = e.offsetX;
            y_on_start = e.offsetY;

            parent_bar_id = bar_wrapper.getAttribute('data-id');
            const ids = [
                parent_bar_id,
                ...this.get_all_dependent_tasks(parent_bar_id)
            ];
            bars = ids.map(id => this.get_bar(id));

            this.bar_being_dragged = parent_bar_id;

            bars.forEach(bar => {
                const $bar = bar.$bar;
                $bar.ox = $bar.getX();
                $bar.oy = $bar.getY();
                $bar.owidth = $bar.getWidth();
                $bar.finaldx = 0;
            });
            e.stopPropagation();
            e.preventDefault();
            return !1;
        });

        $.on(this.$svg, 'mousemove', e => {
            if (!action_in_progress()) return;
            const dx = e.offsetX - x_on_start;
            const dy = e.offsetY - y_on_start;

            bars.forEach(bar => {
                const $bar = bar.$bar;
                $bar.finaldx = this.get_snap_position(dx);

                if (is_resizing_left) {
                    if (parent_bar_id === bar.task.id) {
                        bar.update_bar_position({
                            x: $bar.ox + $bar.finaldx,
                            width: $bar.owidth - $bar.finaldx
                        });
                    } else {
                        bar.update_bar_position({
                            x: $bar.ox + $bar.finaldx
                        });
                    }
                } else if (is_resizing_right) {
                    if (parent_bar_id === bar.task.id) {
                        bar.update_bar_position({
                            width: $bar.owidth + $bar.finaldx
                        });
                    }
                } else if (is_dragging) {
                    bar.update_bar_position({
                        x: $bar.ox + $bar.finaldx
                    });
                }
            });
            e.stopPropagation();
            e.preventDefault();
            return !1;
        });

        document.addEventListener('mouseup', e => {
            if (is_dragging || is_resizing_left || is_resizing_right) {
                bars.forEach(bar => bar.group.classList.remove('active'));
            }

            is_dragging = false;
            is_resizing_left = false;
            is_resizing_right = false;
        });

        $.on(this.$svg, 'mouseup', e => {
            this.bar_being_dragged = null;
            bars.forEach(bar => {
                const $bar = bar.$bar;
                if (!$bar.finaldx) return;
                bar.date_changed();
                bar.set_action_completed();
            });
        });

        this.bind_bar_progress();
    }

    bind_bar_progress() {
        let x_on_start = 0;
        let y_on_start = 0;
        let is_resizing = null;
        let bar = null;
        let $bar_progress = null;
        let $bar = null;

        $.on(this.$svg, 'mousedown', '.handle.progress', (e, handle) => {
            is_resizing = true;
            x_on_start = e.offsetX;
            y_on_start = e.offsetY;

            const $bar_wrapper = $.closest('.bar-wrapper', handle);
            const id = $bar_wrapper.getAttribute('data-id');
            bar = this.get_bar(id);

            $bar_progress = bar.$bar_progress;
            $bar = bar.$bar;

            $bar_progress.finaldx = 0;
            $bar_progress.owidth = $bar_progress.getWidth();
            $bar_progress.min_dx = -$bar_progress.getWidth();
            $bar_progress.max_dx = $bar.getWidth() - $bar_progress.getWidth();
            e.stopPropagation();
            e.preventDefault();
            return !1;
        });

        $.on(this.$svg, 'mousemove', e => {
            if (!is_resizing) return;
            let dx = e.offsetX - x_on_start;
            let dy = e.offsetY - y_on_start;

            if (dx > $bar_progress.max_dx) {
                dx = $bar_progress.max_dx;
            }
            if (dx < $bar_progress.min_dx) {
                dx = $bar_progress.min_dx;
            }

            const $handle = bar.$handle_progress;
            $.attr($bar_progress, 'width', $bar_progress.owidth + dx);
            $.attr($handle, 'points', bar.get_progress_polygon_points());
            $bar_progress.finaldx = dx;
            e.stopPropagation();
            e.preventDefault();
            return !1;
        });

        $.on(this.$svg, 'mouseup', (e) => {
            is_resizing = false;
            if (!($bar_progress && $bar_progress.finaldx)) return;
            bar.progress_changed();
            bar.set_action_completed();
            e.stopPropagation();
            e.preventDefault();
            return !1;
        });
    }

    get_all_dependent_tasks(task_id) {
        let out = [];
        let to_process = [task_id];
        while (to_process.length) {
            const deps = to_process.reduce((acc, curr) => {
                acc = acc.concat(this.dependency_map[curr]);
                return acc;
            }, []);

            out = out.concat(deps);
            to_process = deps.filter(d => !to_process.includes(d));
        }

        return out.filter(Boolean);
    }

    get_snap_position(dx) {
        let odx = dx,
            rem,
            position;

        if (this.view_is(VIEW_MODE.WEEK)) {
            rem = dx % (this.options.column_width / 7);
            position =
                odx -
                rem +
                (rem < this.options.column_width / 14 ?
                    0 :
                    this.options.column_width / 7);
        } else if (this.view_is(VIEW_MODE.MONTH)) {
            rem = dx % (this.options.column_width / 30);
            position =
                odx -
                rem +
                (rem < this.options.column_width / 60 ?
                    0 :
                    this.options.column_width / 30);
        } else {
            rem = dx % this.options.column_width;
            position =
                odx -
                rem +
                (rem < this.options.column_width / 2 ?
                    0 :
                    this.options.column_width);
        }
        return position;
    }

    unselect_all() {
        [...this.$svg.querySelectorAll('.bar-wrapper')].forEach(el => {
            el.classList.remove('active');
        });
    }

    view_is(modes) {
        if (typeof modes === 'string') {
            return this.options.view_mode === modes;
        }

        if (Array.isArray(modes)) {
            return modes.some(mode => this.options.view_mode === mode);
        }

        return false;
    }

    get_task(id) {
        for (let c in this.tasks) {
            let task = this.tasks[c];
            if (task.dependencieId === id) return task;
            if (task.hasOwnProperty('datas')) {
                let task1 = task.datas.find(task2 => {
                    return task2.dependencieId === id;
                });
                if (task1) return task1;
            }
        }
    }

    get_bar(id) {
        return this.bars.find(bar => {
            return bar.task.id === id;
        });
    }

    show_popup(options) {
        if (!this.popup) {
            this.popup = new Popup(
                this.popup_wrapper,
                this.options.custom_popup_html
            );
        }
        this.popup.make();
        this.popup.show(options);
        let x = this.elX;
        let y = this.elY;
        if (options.pos) {
            x = options.pos.x;
            y = options.pos.y;
        }
        let rect = this.$task_content.getBoundingClientRect();
        let $containerwidth = rect.right;
        let $containerheight = rect.bottom;

        if (this.popup.parent.clientWidth + x > $containerwidth) {
            x = $containerwidth - this.popup.parent.clientWidth - 10;
        }
        if (this.popup.parent.clientHeight + y > $containerheight) {
            y = $containerheight - this.popup.parent.clientHeight - 10;
        }

        this.popup.parent.style.left = x - rect.left + 10 + 'px';
        this.popup.parent.style.top = y - rect.top + 10 + 'px';
    }

    hide_popup() {
        this.popup && this.popup.hide();
    }

    trigger_event(event, args) {
        if (this.options['on_' + event]) {
            return this.options['on_' + event].apply(null, args);
        }
    }

    /**
     * Gets the oldest starting date from the list of tasks
     *
     * @returns Date
     * @memberof Gantt
     */
    get_oldest_starting_date() {
        return this.tasks
            .map(task => task._start)
            .reduce(
                (prev_date, cur_date) =>
                cur_date <= prev_date ? cur_date : prev_date
            );
    }

    /**
     * Clear all elements from the parent svg element
     *
     * @memberof Gantt
     */
    clear() {
        this.$svg.innerHTML = '';
        this.$svg_header.innerHTML = '';
    }
}

Gantt.VIEW_MODE = VIEW_MODE;

function generate_id(task) {
    return (
        task.name +
        '_' +
        Math.random()
        .toString(36)
        .slice(2, 12)
    );
}